module.exports = __webpack_public_path__ + "static/media/goal.60d780a0.svg";